import { render, staticRenderFns } from "./menu4_video_clip_q.vue?vue&type=template&id=d0bb8c88&scoped=true"
import script from "./menu4_video_clip_q.vue?vue&type=script&lang=js"
export * from "./menu4_video_clip_q.vue?vue&type=script&lang=js"
import style0 from "./menu4_video_clip_q.vue?vue&type=style&index=0&id=d0bb8c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0bb8c88",
  null
  
)

export default component.exports